import React from 'react';
import SVGImage from '../layout/SVGImage';

interface StatusIndicatorProps {
  testId?: string;
  className?: string;
  isError?: boolean;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  testId,
  className,
  isError,
}) => {
  const dynamicClass = isError
    ? 'bg-[#FFB9B9] [&>div:first-child]:bg-red-dark [&>p:last-child]:text-[#7C0204]'
    : 'bg-[#B9D6FF] [&>div:first-child]:bg-blue-light [&>p:last-child]:text-[#02087C]';

  const dynamicText = isError
    ? '위치정보를 일시적으로 가져올 수 없습니다.'
    : '잠시만 기다려주세요.';

  const dynamicSvgName = isError ? 'error' : 'dropdown-spinner';

  return (
    <div
      data-testid={testId}
      className={`${dynamicClass} flex h-[40px] w-[240px] items-center rounded-[5px] ${className}`}
    >
      <div className="h-[40px] w-[4px] rounded-l-[5px] bg-blue-light"></div>
      <SVGImage
        className="ml-[10px] h-[14px] w-[14px]"
        width={14}
        height={14}
        fill={isError ? '#B70003' : ''}
        name={dynamicSvgName}
      />
      <p className="noto-11-normal ml-[10px] leading-none tracking-[-0.5px]">
        {dynamicText}
      </p>
    </div>
  );
};
